// extracted by mini-css-extract-plugin
export default {"strip":"MarqueeStrip_strip__2iXM4","track":"MarqueeStrip_track__JOa0w","marquee":"MarqueeStrip_marquee__Tt0jH","item":"MarqueeStrip_item__voNgF"};